<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCol sm="12" lg="12">
              <img
                src="../assets/img/bgFaq.jpg"
                style="max-width: 100%"
                class="text-center"
              />
            </CCol>
            <div class="text-center text-title text-bold">
              <h2 class="display-5">Add Frequently Asked Question</h2>
              <h6 class="text-muted m-3 display-6">
                We're here to help you with anything and <br />everything on
                Pickiddo
              </h6>
            </div>

            <div class="m-2 p-2">
              <CRow>
                <CCol sm="12" lg="12">
                  Group FAQ
                  <CInput
                    v-model="FaqGroup"
                    placeholder="Enter Group FAQ"
                  />
                </CCol>

                <CCol sm="12" lg="12">
                  Question
                  <CTextarea
                    v-model="Question"
                    placeholder="Enter Your Question"
                    vertical
                    rows="3"
                  />
                </CCol>

                <CCol sm="12" lg="12">
                  Answer
                  <CTextarea
                    v-model="Answer"
                    placeholder="Enter Your Question"
                    vertical
                    rows="3"
                  />
                </CCol>

                <CCol sm="12" lg="12">
                     <CButton
                    type="submit"
                    color="primary"
                    class="p-2"
                    @click="InsertFaq"
                    block
                    >Proceed</CButton
                  >
                </CCol>
              </CRow>
            </div>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>



<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";

export default {
  name: "Collapses",
  data() {
    return {
      FaqGroup: "",
    };
  },
  async mounted() {},
  methods: {
    InsertFaq() {
      const formData = new FormData();

      formData.append("FaqGroup", this.FaqGroup);
      formData.append("Question", this.Question);
      formData.append("Answer", this.Answer);

      return this.$API
        .post(this.$InsertFaq, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.$dialog.alert("You have successfully save faq").then(function (dialog) {
                console.log("Closed");
              });
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
          }
        });
    },
  },
};
</script>